import {Nullable} from "../../models/common/Nullable";
import {ProjectRole} from "../../models/projects/ProjectRole";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    CREATE_PROJECT_ROLE, CREATE_PROJECT_ROLE_ERROR, CREATE_PROJECT_ROLE_SUCCESS,
    DELETE_PROJECT_ROLE, DELETE_PROJECT_ROLE_ERROR, DELETE_PROJECT_ROLE_SUCCESS,
    FETCH_PROJECT_ROLE_BY_ID, FETCH_PROJECT_ROLE_BY_ID_ERROR, FETCH_PROJECT_ROLE_BY_ID_SUCCESS,
    FETCH_PROJECT_ROLES, FETCH_PROJECT_ROLES_ERROR, FETCH_PROJECT_ROLES_SUCCESS,
    ProjectRoleActionTypes,
    RESTORE_PROJECT_ROLE, RESTORE_PROJECT_ROLE_ERROR, RESTORE_PROJECT_ROLE_SUCCESS,
    UPDATE_PROJECT_ROLE, UPDATE_PROJECT_ROLE_ERROR, UPDATE_PROJECT_ROLE_SUCCESS
} from "../../actions/projects/ProjectRoleActions";

export interface ProjectRolesState {
    totalEntries: number
    entries: {
        current: Nullable< ProjectRole[] >
        request: RequestState
    }
    detailedEntries: { [ key: number ]: {
        projectRole: Nullable< ProjectRole >,
        request: RequestState
    } },
    changingRequest: RequestState

}

const initialState: ProjectRolesState = {
    totalEntries: 0,
    entries: {
        current: null,
        request: getInitialRequestState()
    },
    detailedEntries: {},
    changingRequest: getInitialRequestState()
}

/**
 * PROJECT ROLES REDUCER
 *
 * @see ProjectRoleActionTypes
 * @see ProjectRoleModule
 */
export function ProjectRolesReducer(
    state: ProjectRolesState = initialState,
    action: ProjectRoleActionTypes
) {

    switch( action.type ) {
        case FETCH_PROJECT_ROLES:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: startFetchingRequestState()
                },
            };
        case FETCH_PROJECT_ROLES_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    current: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_PROJECT_ROLES_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_PROJECT_ROLE_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.projectRoleId.rawValue ]: {
                        projectRole: null,
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_PROJECT_ROLE_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.role.projectRoleId.rawValue ]: {
                        projectRole: action.role,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_PROJECT_ROLE_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.projectRoleId.rawValue ]: {
                        ...state.detailedEntries[ action.projectRoleId.rawValue ],
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case CREATE_PROJECT_ROLE:
        case UPDATE_PROJECT_ROLE:
        case DELETE_PROJECT_ROLE:
        case RESTORE_PROJECT_ROLE:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case CREATE_PROJECT_ROLE_SUCCESS:
        case UPDATE_PROJECT_ROLE_SUCCESS:
        case DELETE_PROJECT_ROLE_SUCCESS:
        case RESTORE_PROJECT_ROLE_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case CREATE_PROJECT_ROLE_ERROR:
        case UPDATE_PROJECT_ROLE_ERROR:
        case DELETE_PROJECT_ROLE_ERROR:
        case RESTORE_PROJECT_ROLE_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };
        default:
            return state;
    }

}